import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./layout/Default";
import { withAuth } from "./components/HOC/withAuth";
import Login from "./views/auth/Login";
import DeviceModels from "./views/pages/DeviceModels";
import SerialNumbers from "./views/pages/SerialNumbers";
import DeviceSales from "./views/pages/DeviceSales";
import CreateDeviceSale from "./views/pages/DeviceSales/CreateDeviceSale";
import EditDeviceSale from "./views/pages/DeviceSales/EditDeviceSale";
import Users from "./views/pages/Users";
import CreateDeviceModel from "./views/pages/DeviceModels/CreateDeviceModel";
import Products from "./views/pages/Products";
import Companies from "./views/pages/Companies";
import CreateCompany from "./views/pages/Companies/CreateCompany";
import Dealers from "./views/pages/Dealers";
import CreateDealer from "./views/pages/Dealers/CreateDealer";
import Page404 from "./views/pages/Page404";
import ProducedDevices from "./views/pages/ProducedDevices";
import Activities from "./views/pages/Activities";
import ActivityDetails from "./views/pages/Activities/ActivityDetails";
import Machines from "./views/pages/Machines";
import MachineAssignments from "./views/pages/MachineAssignments";
import CreateMachineAssignment from "./views/pages/MachineAssignments/CreateMachineAssignment";
import EditMachineAssignment from "./views/pages/MachineAssignments/EditMachineAssignment";
import Deliveries from "./views/pages/Deliveries";
import CreateDelivery from "./views/pages/Deliveries/CreateDelivery";
import ViewDelivery from "./views/pages/Deliveries/ViewDelivery";
import StockProducts from "./views/pages/StockProducts";
import Profile from "./views/pages/Profile";
import BankAccounts from "./views/pages/BankAccounts";
import CompanySettings from "./views/pages/CompanySettings";
import DeviceMonitor from "./views/pages/DeviceMonitor";
import AssemblyProducts from "./views/pages/AssemblyProducts";
import Logs from "./views/pages/Logs";
import DefectiveProducts from "./views/pages/DefectiveProducts";
import PackagingProducts from "./views/pages/PackagingProducts";
import PrivacyPolicy from "./views/pages/PrivacyPolicy";
import CompanyDetails from "./views/pages/Companies/CompanyDetails";
import UserProfiles from "./views/pages/UserProfiles";
import Inventory from "./views/pages/Inventory";
import InventoryTree from "./views/pages/Inventory/InventoryTree";
import AddInventory from "./views/pages/Inventory/AddInventory";
import InventoryAdditions from "./views/pages/Inventory/InventoryAdditions";
import ProductionLines from "./views/pages/ProductionLines";
import ProductionLineFormPage from "./views/pages/ProductionLines/ProductionLineFormPage";
import ViewProductionLines from "./views/pages/ProductionLines/ViewProductionLines";
import SubProductionLines from "./views/pages/ProductionLines/SubProductionLines";
import ViewSubProductionLines from "./views/pages/ProductionLines/ViewSubProductionLines";
import ProductionLogs from "./views/pages/ProductionLogs";
import ProductionEntry from "./views/pages/ProductionLines/ProductionEntry";
import Orders from "./views/pages/Orders";
import PermissionApproves from "./views/pages/PermissionApproves";
import CreateOrder from "./views/pages/Orders/CreateOrder";
import Devices from "./views/pages/Devices";
import Shifts from "./views/pages/Shifts";
import ShiftForm from "./views/pages/Shifts/ShiftForm";
import StopReasons from "./views/pages/StopReasons";
import StoppingGroups from "./views/pages/StoppingGroups";
import OEEGroups from "./views/pages/OEEGroups";
import OEEClasses from "./views/pages/OEEClasses";
import MachineStopLogs from "./views/pages/MachineStopLogs";
import TEEP from "./views/pages/TEEP";
import MachineMonitor from "./views/pages/MachineMonitor";
import MachineReport from "./views/pages/MachineReport";
import Parts from "./views/pages/Parts";
import PartMachines from "./views/pages/PartMachines";
import PartMachineAssignmentForm from "./views/pages/PartMachines/AssignmentForm";
import PartMachineAssignmentView from "./views/pages/PartMachines/ViewAssignment";
import PartAssemblies from "./views/pages/PartAssemblies";
import PartStockAdditions from "./views/pages/Parts/PartStockAdditions";
import PartUnits from "./views/pages/PartUnits";
import PartVariants from "./views/pages/PartVariants";
import ScrapEntry from "./views/pages/ScrapEntry";
import ScrapGroups from "./views/pages/ScrapGroups";
import EPC from "./views/pages/EPC";
import OEEReport from "./views/pages/Reports/OEE";
import OEEByMachineReport from "./views/pages/Reports/OEE/ByMachine";
import ProductionReportRedirect from "./views/pages/Reports/Production";
import ProductionByPartPerPart from "./views/pages/Reports/Production/ByPart/PerPart";
import ProductionByPartTrend from "./views/pages/Reports/Production/ByPart/Trend";
import ProductionByPartMatrix from "./views/pages/Reports/Production/ByPart/Matrix";
import ProductionByMachineTrend from "./views/pages/Reports/Production/ByMachine/Trend";
import ProductionByMachineDistribution from "./views/pages/Reports/Production/ByMachine/Distribution";
import ProductionByMachineTotals from "./views/pages/Reports/Production/ByMachine/Totals";
import QualityReportRedirect from "./views/pages/Reports/Quality";
import QualityTrendReport from "./views/pages/Reports/Quality/Trend";
import QualityByPartReport from "./views/pages/Reports/Quality/ByPart";
import DowntimeReportRedirect from "./views/pages/Reports/Downtime";
import DowntimeTrendReport from "./views/pages/Reports/Downtime/Trend";
import DowntimeReasonsReport from "./views/pages/Reports/Downtime/Reasons";
import DowntimeByMachineReport from "./views/pages/Reports/Downtime/ByMachine";
import DeviceStatusReport from "./views/pages/Reports/DeviceStatus";
import ActivitiesReport from "./views/pages/Reports/Activities";
import SalesReportRedirect from "./views/pages/Reports/Sales";
import SalesTrendReport from "./views/pages/Reports/Sales/Trend";
import SalesByModelReport from "./views/pages/Reports/Sales/ByModel";
import SalesRevenueReport from "./views/pages/Reports/Sales/Revenue";
import DeliveriesReportRedirect from "./views/pages/Reports/Deliveries";
import DeliveriesTrendReport from "./views/pages/Reports/Deliveries/Trend";
import DeliveriesByModelReport from "./views/pages/Reports/Deliveries/ByModel";
import ProductionPlans from "./views/pages/ProductionPlanning/Plans";
import ProductionFeasibility from "./views/pages/ProductionPlanning/Feasibility";
import ProductionShortage from "./views/pages/ProductionPlanning/Shortage"; 
import SystemCompanies from "./views/pages/SystemCompanies";
import ProfileForm from "./views/pages/UserProfiles/ProfileForm";
import Licenses from "./views/pages/Licenses";
import NotificationsPage from "./views/pages/Notifications";
import NotificationSettingsPage from "./views/pages/NotificationSettings";
import ApprovalWorkflows from "./views/pages/ApprovalWorkflows";
import WorkflowForm from "./views/pages/ApprovalWorkflows/WorkflowForm";
import ProductionCapacity from "./views/pages/ProductionCapacity";

// Protected route components
const ProtectedProducts = withAuth(Products);
const ProtectedAssemblyProducts = withAuth(AssemblyProducts);
const ProtectedPackagingProducts = withAuth(PackagingProducts);
const ProtectedDefectiveProducts = withAuth(DefectiveProducts);
const ProtectedStockProducts = withAuth(StockProducts);
const ProtectedCompanies = withAuth(Companies);
const ProtectedCreateCompany = withAuth(CreateCompany);
const ProtectedDealers = withAuth(Dealers);
const ProtectedCreateDealer = withAuth(CreateDealer);
const ProtectedDeviceModels = withAuth(DeviceModels);
const ProtectedCreateDeviceModel = withAuth(CreateDeviceModel);
const ProtectedSerialNumbers = withAuth(SerialNumbers);
const ProtectedDeviceSales = withAuth(DeviceSales);
const ProtectedCreateDeviceSale = withAuth(CreateDeviceSale);
const ProtectedEditDeviceSale = withAuth(EditDeviceSale);
const ProtectedProducedDevices = withAuth(ProducedDevices);
const ProtectedActivities = withAuth(Activities);
const ProtectedActivityDetails = withAuth(ActivityDetails);
const ProtectedDevices = withAuth(Devices);
const ProtectedMachines = withAuth(Machines);
const ProtectedMachineAssignments = withAuth(MachineAssignments);
const ProtectedCreateMachineAssignment = withAuth(CreateMachineAssignment);
const ProtectedEditMachineAssignment = withAuth(EditMachineAssignment);
const ProtectedDeliveries = withAuth(Deliveries);
const ProtectedCreateDelivery = withAuth(CreateDelivery);
const ProtectedEditDelivery = withAuth(CreateDelivery);
const ProtectedViewDelivery = withAuth(ViewDelivery);
const ProtectedProfile = withAuth(Profile);
const ProtectedBankAccounts = withAuth(BankAccounts);
const ProtectedCompanySettings = withAuth(CompanySettings);
const ProtectedDeviceMonitor = withAuth(DeviceMonitor);
const ProtectedCompanyDetails = withAuth(CompanyDetails);
const ProtectedInventory = withAuth(Inventory);
const ProtectedInventoryTree = withAuth(InventoryTree);
const ProtectedAddInventory = withAuth(AddInventory);
const ProtectedInventoryAdditions = withAuth(InventoryAdditions);
const ProtectedProductionLines = withAuth(ProductionLines);
const ProtectedProductionLineFormPage = withAuth(ProductionLineFormPage);
const ProtectedViewProductionLines = withAuth(ViewProductionLines);
const ProtectedSubProductionLines = withAuth(SubProductionLines);
const ProtectedViewSubProductionLines = withAuth(ViewSubProductionLines);
const ProtectedProductionLogs = withAuth(ProductionLogs);
const ProtectedProductionEntry = withAuth(ProductionEntry);
const ProtectedOrders = withAuth(Orders);
const ProtectedCreateOrder = withAuth(CreateOrder);
const ProtectedPermissionApproves = withAuth(PermissionApproves);
// Admin-only pages
const ProtectedUsers = withAuth(Users);
const ProtectedLogs = withAuth(Logs);
const ProtectedUserProfiles = withAuth(UserProfiles);
const ProtectedShifts = withAuth(Shifts);
const ProtectedShiftForm = withAuth(ShiftForm);
const ProtectedStopReasons = withAuth(StopReasons);
const ProtectedStoppingGroups = withAuth(StoppingGroups);
const ProtectedOEEGroups = withAuth(OEEGroups);
const ProtectedOEEClasses = withAuth(OEEClasses);
const ProtectedMachineStopLogs = withAuth(MachineStopLogs);
const ProtectedTEEP = withAuth(TEEP);
const ProtectedMachineMonitor = withAuth(MachineMonitor);
const ProtectedMachineReport = withAuth(MachineReport);
const ProtectedParts = withAuth(Parts);
const ProtectedPartMachines = withAuth(PartMachines);
const ProtectedPartMachineAssignmentForm = withAuth(PartMachineAssignmentForm);
const ProtectedPartMachineAssignmentView = withAuth(PartMachineAssignmentView);
const ProtectedPartAssemblies = withAuth(PartAssemblies);
const ProtectedPartUnits = withAuth(PartUnits);
const ProtectedPartVariants = withAuth(PartVariants);
const ProtectedPartStockAdditions = withAuth(PartStockAdditions);
const ProtectedScrapEntry = withAuth(ScrapEntry);
const ProtectedScrapGroups = withAuth(ScrapGroups);
const ProtectedEPC = withAuth(EPC);
const ProtectedOEEReport = withAuth(OEEReport);
const ProtectedOEEByMachineReport = withAuth(OEEByMachineReport);
const ProtectedProductionReportRedirect = withAuth(ProductionReportRedirect);
const ProtectedProductionByPartPerPart = withAuth(ProductionByPartPerPart);
const ProtectedProductionByPartTrend = withAuth(ProductionByPartTrend);
const ProtectedProductionByPartMatrix = withAuth(ProductionByPartMatrix);
const ProtectedProductionByMachineTrend = withAuth(ProductionByMachineTrend);
const ProtectedProductionByMachineDistribution = withAuth(
  ProductionByMachineDistribution,
);
const ProtectedProductionByMachineTotals = withAuth(ProductionByMachineTotals);
const ProtectedQualityReportRedirect = withAuth(QualityReportRedirect);
const ProtectedQualityTrendReport = withAuth(QualityTrendReport);
const ProtectedQualityByPartReport = withAuth(QualityByPartReport);
const ProtectedDowntimeReportRedirect = withAuth(DowntimeReportRedirect);
const ProtectedDowntimeTrendReport = withAuth(DowntimeTrendReport);
const ProtectedDowntimeReasonsReport = withAuth(DowntimeReasonsReport);
const ProtectedDowntimeByMachineReport = withAuth(DowntimeByMachineReport);
const ProtectedDeviceStatusReport = withAuth(DeviceStatusReport);
const ProtectedActivitiesReport = withAuth(ActivitiesReport);
const ProtectedSalesReportRedirect = withAuth(SalesReportRedirect);
const ProtectedSalesTrendReport = withAuth(SalesTrendReport);
const ProtectedSalesByModelReport = withAuth(SalesByModelReport);
const ProtectedSalesRevenueReport = withAuth(SalesRevenueReport);
const ProtectedDeliveriesReportRedirect = withAuth(DeliveriesReportRedirect);
const ProtectedDeliveriesTrendReport = withAuth(DeliveriesTrendReport);
const ProtectedDeliveriesByModelReport = withAuth(DeliveriesByModelReport);
const ProtectedProductionPlans = withAuth(ProductionPlans);
const ProtectedProductionFeasibility = withAuth(ProductionFeasibility);
const ProtectedProductionShortage = withAuth(ProductionShortage);
const ProtectedSystemCompanies = withAuth(SystemCompanies);
const ProtectedProfileForm = withAuth(ProfileForm);
const ProtectedLicenses = withAuth(Licenses);
// Notification pages — NotificationsPage and NotificationSettingsPage export withAuth internally
const ProtectedNotifications = NotificationsPage;
const ProtectedNotificationSettings = NotificationSettingsPage;
const ProtectedApprovalWorkflows = withAuth(ApprovalWorkflows);
const ProtectedWorkflowForm = withAuth(WorkflowForm);
const ProtectedProductionCapacity = withAuth(ProductionCapacity);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="/device-models" replace />} />
          <Route path="404" element={<Page404 />} />
          <Route path="products" element={<ProtectedProducts />} />
          <Route
            path="assembly-products"
            element={<ProtectedAssemblyProducts />}
          />
          <Route
            path="packaging-products"
            element={<ProtectedPackagingProducts />}
          />
          <Route
            path="defective-products"
            element={<ProtectedDefectiveProducts />}
          />
          <Route path="stock-products" element={<ProtectedStockProducts />} />
          <Route path="companies" element={<ProtectedCompanies />} />
          <Route path="companies/create" element={<ProtectedCreateCompany />} />
          <Route path="companies/:code" element={<ProtectedCompanyDetails />} />
          <Route path="dealers" element={<ProtectedDealers />} />
          <Route path="dealers/create" element={<ProtectedCreateDealer />} />
          <Route path="device-models" element={<ProtectedDeviceModels />} />
          <Route
            path="device-models/create"
            element={<ProtectedCreateDeviceModel />}
          />
          <Route path="serial-numbers" element={<ProtectedSerialNumbers />} />
          <Route path="device-sales" element={<ProtectedDeviceSales />} />
          <Route
            path="device-sales/create"
            element={<ProtectedCreateDeviceSale />}
          />
          <Route
            path="produced-devices"
            element={<ProtectedProducedDevices />}
          />
          <Route path="activities" element={<ProtectedActivities />} />
          <Route
            path="activities/:type/:id"
            element={<ProtectedActivityDetails />}
          />
          <Route path="devices" element={<ProtectedDevices />} />
          <Route path="machines" element={<ProtectedMachines />} />
          <Route
            path="machine-assignments"
            element={<ProtectedMachineAssignments />}
          />
          <Route
            path="machine-assignments/create"
            element={<ProtectedCreateMachineAssignment />}
          />
          <Route
            path="machine-assignments/edit/:assignmentId"
            element={<ProtectedEditMachineAssignment />}
          />
          <Route path="deliveries" element={<ProtectedDeliveries />} />
          <Route
            path="deliveries/create"
            element={<ProtectedCreateDelivery />}
          />
          <Route
            path="deliveries/edit/:deliveryId"
            element={<ProtectedEditDelivery />}
          />
          <Route
            path="deliveries/view/:deliveryId"
            element={<ProtectedViewDelivery />}
          />
          <Route
            path="device-sales/edit/:saleId"
            element={<ProtectedEditDeviceSale />}
          />
          <Route path="users" element={<ProtectedUsers />} />
          <Route path="user-profiles" element={<ProtectedUserProfiles />} />
          <Route path="account/profile" element={<ProtectedProfile />} />
          <Route path="account/bank-accounts" element={<ProtectedBankAccounts />} />
          <Route path="account/company-settings" element={<ProtectedCompanySettings />} />
          <Route path="device-monitor" element={<ProtectedDeviceMonitor />} />
          <Route path="logs" element={<ProtectedLogs />} />
          <Route path="inventory" element={<ProtectedInventory />} />
          <Route path="inventory/add" element={<ProtectedAddInventory />} />
          <Route
            path="inventory/add/:itemId"
            element={<ProtectedAddInventory />}
          />
          <Route
            path="inventory/additions"
            element={<ProtectedInventoryAdditions />}
          />
          <Route path="inventory-tree" element={<ProtectedInventoryTree />} />
          <Route
            path="production-lines"
            element={<ProtectedProductionLines />}
          />
          <Route
            path="production-lines/create"
            element={<ProtectedProductionLineFormPage />}
          />
          <Route
            path="production-lines/edit/:id"
            element={<ProtectedProductionLineFormPage />}
          />
          <Route
            path="production-lines/view/:id"
            element={<ProtectedViewProductionLines />}
          />
          <Route
            path="production-lines/sub"
            element={<ProtectedSubProductionLines />}
          />
          <Route
            path="production-lines/sub/view/:id"
            element={<ProtectedViewSubProductionLines />}
          />
          <Route path="production-logs" element={<ProtectedProductionLogs />} />
          <Route
            path="production-entry"
            element={<ProtectedProductionEntry />}
          />
          <Route path="orders" element={<ProtectedOrders />} />
          <Route path="orders/create" element={<ProtectedCreateOrder />} />
          <Route
            path="orders/edit/:orderId"
            element={<ProtectedCreateOrder />}
          />
          <Route
            path="permission-approves"
            element={<ProtectedPermissionApproves />}
          />
          <Route path="shifts" element={<ProtectedShifts />} />
          <Route path="shifts/create" element={<ProtectedShiftForm />} />
          <Route path="shifts/edit/:shiftId" element={<ProtectedShiftForm />} />
          <Route path="stop-reasons" element={<ProtectedStopReasons />} />
          <Route path="stopping-groups" element={<ProtectedStoppingGroups />} />
          <Route path="oee-groups" element={<ProtectedOEEGroups />} />
          <Route path="oee-classes" element={<ProtectedOEEClasses />} />
          <Route
            path="machine-stop-logs"
            element={<ProtectedMachineStopLogs />}
          />
          <Route path="teep" element={<ProtectedTEEP />} />
          <Route path="machine-monitor" element={<ProtectedMachineMonitor />} />
          <Route path="parts" element={<ProtectedParts />} />
          <Route path="part-machines" element={<ProtectedPartMachines />} />
          <Route
            path="part-machines/assign"
            element={<ProtectedPartMachineAssignmentForm />}
          />
          <Route
            path="part-machines/assign/:machineId"
            element={<ProtectedPartMachineAssignmentForm />}
          />
          <Route
            path="part-machines/view/:machineId"
            element={<ProtectedPartMachineAssignmentView />}
          />
          <Route path="part-assemblies" element={<ProtectedPartAssemblies />} />
          <Route path="part-units" element={<ProtectedPartUnits />} />
          <Route path="part-variants" element={<ProtectedPartVariants />} />
          <Route path="scrap-entry" element={<ProtectedScrapEntry />} />
          <Route path="scrap-groups" element={<ProtectedScrapGroups />} />
          <Route path="epc" element={<ProtectedEPC />} />
          <Route
            path="parts/:id/stock-additions"
            element={<ProtectedPartStockAdditions />}
          />
          <Route path="reports/oee" element={<ProtectedOEEReport />} />
          <Route
            path="reports/oee/by-machine"
            element={<ProtectedOEEByMachineReport />}
          />
          <Route
            path="reports/oee/stop-reasons"
            element={<Navigate to="/reports/downtime/reasons" replace />}
          />
          <Route
            path="reports/production"
            element={<ProtectedProductionReportRedirect />}
          />
          <Route
            path="reports/production/by-part/per-part"
            element={<ProtectedProductionByPartPerPart />}
          />
          <Route
            path="reports/production/by-part/trend"
            element={<ProtectedProductionByPartTrend />}
          />
          <Route
            path="reports/production/by-part/matrix"
            element={<ProtectedProductionByPartMatrix />}
          />
          <Route
            path="reports/production/by-machine/trend"
            element={<ProtectedProductionByMachineTrend />}
          />
          <Route
            path="reports/production/by-machine/distribution"
            element={<ProtectedProductionByMachineDistribution />}
          />
          <Route
            path="reports/production/by-machine/totals"
            element={<ProtectedProductionByMachineTotals />}
          />
          <Route
            path="reports/quality"
            element={<ProtectedQualityReportRedirect />}
          />
          <Route
            path="reports/quality/trend"
            element={<ProtectedQualityTrendReport />}
          />
          <Route
            path="reports/quality/by-part"
            element={<ProtectedQualityByPartReport />}
          />
          <Route
            path="reports/downtime"
            element={<ProtectedDowntimeReportRedirect />}
          />
          <Route
            path="reports/downtime/trend"
            element={<ProtectedDowntimeTrendReport />}
          />
          <Route
            path="reports/downtime/reasons"
            element={<ProtectedDowntimeReasonsReport />}
          />
          <Route
            path="reports/downtime/by-machine"
            element={<ProtectedDowntimeByMachineReport />}
          />
          <Route
            path="reports/device-status"
            element={<ProtectedDeviceStatusReport />}
          />
          <Route
            path="reports/activities"
            element={<ProtectedActivitiesReport />}
          />
          <Route
            path="reports/sales"
            element={<ProtectedSalesReportRedirect />}
          />
          <Route
            path="reports/sales/trend"
            element={<ProtectedSalesTrendReport />}
          />
          <Route
            path="reports/sales/by-model"
            element={<ProtectedSalesByModelReport />}
          />
          <Route
            path="reports/sales/revenue"
            element={<ProtectedSalesRevenueReport />}
          />
          <Route
            path="reports/deliveries"
            element={<ProtectedDeliveriesReportRedirect />}
          />
          <Route
            path="reports/deliveries/trend"
            element={<ProtectedDeliveriesTrendReport />}
          />
          <Route
            path="reports/deliveries/by-model"
            element={<ProtectedDeliveriesByModelReport />}
          />
          <Route
            path="reports/machine-report"
            element={<ProtectedMachineReport />}
          />
          <Route
            path="production-planning"
            element={<ProtectedProductionPlans />}
          />
          <Route
            path="production-planning/plans"
            element={<ProtectedProductionPlans />}
          />
          <Route
            path="production-planning/feasibility"
            element={<ProtectedProductionFeasibility />}
          />
          <Route
            path="production-planning/shortage"
            element={<ProtectedProductionShortage />}
          />
          <Route path="system/companies" element={<ProtectedSystemCompanies />} />
          <Route path="system/licenses" element={<ProtectedLicenses />} />
          <Route path="user-profiles/add" element={<ProtectedProfileForm />} />
          <Route path="user-profiles/edit/:id" element={<ProtectedProfileForm />} />
          <Route path="notifications" element={<ProtectedNotifications />} />
          <Route path="settings/notifications" element={<ProtectedNotificationSettings />} />
          <Route path="approval-workflows" element={<ProtectedApprovalWorkflows />} />
          <Route path="approval-workflows/new" element={<ProtectedWorkflowForm />} />
          <Route path="approval-workflows/edit/:id" element={<ProtectedWorkflowForm />} />
          <Route path="production-capacity" element={<ProtectedProductionCapacity />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
